
export const maskIfHidden = (value, hide, isAdmin = false) => {
    const shouldHide = hide && !isAdmin;
    return shouldHide ? '***' : (value || '');
};

export const maskAddressIfHidden = (address, hide, isAdmin = false) => {
    const shouldHide = hide && !isAdmin;
    return shouldHide ? '***' : (address || '');
};
